import { useMemo } from 'react';

export const useProductSorting = (
  products: any[] | undefined,
  category: string | undefined,
  allReviews: any[] | undefined,
  cartData: any[] | undefined
) => {
  return useMemo(() => {
    if (!products) return [];
    let filteredProducts = [...products];

    switch (category) {
      case '1': // All
        return filteredProducts;

      case '2': { // Top Rated
        const ratings = new Map();
        (allReviews || []).forEach(review => {
          const avg = ratings.get(review.product) || { total: 0, count: 0 };
          avg.total += review.rank;
          avg.count++;
          ratings.set(review.product, avg);
        });

        filteredProducts.sort((a, b) => {
          const aAvg = (ratings.get(a.id)?.total || 0) / (ratings.get(a.id)?.count || 1);
          const bAvg = (ratings.get(b.id)?.total || 0) / (ratings.get(b.id)?.count || 1);
          return bAvg - aAvg;
        });
        break;
      }

      case '3': // Popular
        filteredProducts.sort((a, b) => {
          const aOrders = cartData?.filter(order => order.product === a.id) || [];
          const bOrders = cartData?.filter(order => order.product === b.id) || [];
          return bOrders.length - aOrders.length;
        });
        break;

      case '4': // New Arrivals
        filteredProducts.sort((a, b) =>
          new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
        );
        break;
    }

    return filteredProducts;
  }, [products, category, allReviews, cartData]);
}; 